import { render, staticRenderFns } from "./riskTargetProcessDetail.vue?vue&type=template&id=6d197ea2"
import script from "./riskTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./riskTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d197ea2')) {
      api.createRecord('6d197ea2', component.options)
    } else {
      api.reload('6d197ea2', component.options)
    }
    module.hot.accept("./riskTargetProcessDetail.vue?vue&type=template&id=6d197ea2", function () {
      api.rerender('6d197ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskTargetProcessDetail.vue"
export default component.exports